const DEFAULT_VALHALLA_URL = 'https://valhalla.coolify-develop.e-containers.eu'

const decodePolyline = (shape, precision = 6) => {
  /* eslint-disable no-bitwise */
  let index = 0
  let lat = 0
  let long = 0
  const coordinates = []
  const factor = 10 ** precision

  while (index < shape.length) {
    let byte
    let shift = 0
    let result = 0

    do {
      byte = shape.charCodeAt(index) - 63
      index += 1
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)

    const latitudeChange = result & 1 ? ~(result >> 1) : result >> 1
    lat += latitudeChange
    shift = 0
    result = 0

    do {
      byte = shape.charCodeAt(index) - 63
      index += 1
      result |= (byte & 0x1f) << shift
      shift += 5
    } while (byte >= 0x20)

    const longitudeChange = result & 1 ? ~(result >> 1) : result >> 1
    long += longitudeChange
    coordinates.push([long / factor, lat / factor])
  }

  /* eslint-enable no-bitwise */

  return coordinates
}

const getLegCoordinates = leg => {
  if (!leg || !leg.shape) return []
  if (Array.isArray(leg.shape)) return leg.shape
  if (leg.shape.coordinates) return leg.shape.coordinates
  return decodePolyline(leg.shape)
}

const getTripRouteDetails = trip => {
  const legs = trip && trip.legs ? trip.legs : []
  const summary = trip && trip.summary
  const distanceKm = Number(summary && summary.length)

  const coordinates = legs.reduce((routeCoordinates, leg) => {
    const legCoordinates = getLegCoordinates(leg)
    return routeCoordinates.concat(
      routeCoordinates.length ? legCoordinates.slice(1) : legCoordinates
    )
  }, [])

  return {
    coordinates,
    distanceKm: Number.isFinite(distanceKm) ? distanceKm : null
  }
}

export const getValhallaRouteDetails = async (from, to, signal) => {
  const valhallaUrl = process.env.GATSBY_VALHALLA_URL || DEFAULT_VALHALLA_URL

  const response = await fetch(`${valhallaUrl.replace(/\/$/, '')}/route`, {
    method: 'POST',
    headers: { 'Content-Type': 'text/plain' },
    signal,
    body: JSON.stringify({
      locations: [
        { lat: from[1], lon: from[0] },
        { lat: to[1], lon: to[0] }
      ],
      costing: 'truck',
      alternates: 2,
      units: 'kilometers',
      shape_format: 'polyline6',
      directions_type: 'none',
      directions_options: { units: 'kilometers' }
    })
  })

  if (!response.ok) {
    throw new Error(`Valhalla route request failed: ${response.status}`)
  }

  const data = await response.json()
  const route = getTripRouteDetails(data && data.trip)
  const alternates = Array.isArray(data && data.alternates)
    ? data.alternates
        .map(alternate => getTripRouteDetails(alternate && alternate.trip))
        .filter(alternate => alternate.coordinates.length > 1)
    : []

  return {
    ...route,
    alternates
  }
}
